export default {"src":"/_next/static/media/Comet-animation.dafd59a6.gif","height":1084,"width":1930};